export default __webpack_public_path__ + "static/media/ukimage.6b0b1398.jpeg";